module.exports = __webpack_public_path__ + "img/thumbnail_StandardDonkey_f_leucistic.34ef1b5d.png";